import React, { ComponentProps } from 'react'

import { styled } from 'nativewind'

import { YStack } from '../layout'
import Pressable from '../pressable'
import Tag from '../tag/Tag'
import { B2 } from '../typography'

const PressableTagFrame = styled(
  Pressable,
  'active:bg-slate-50 w-[33%] items-center'
)
const IconFrame = styled(YStack, 'p-3 justify-center items-center')
const TileText = styled(B2, 'text-grays-80 text-center')

type PressableFrameProps = ComponentProps<typeof PressableTagFrame>
type IconFrameProps = ComponentProps<typeof IconFrame>
type TitleTextProps = ComponentProps<typeof TileText>

type TileTagProps = PressableFrameProps &
  IconFrameProps &
  TitleTextProps & {
    CardIcon: React.ReactNode
    cardTagTop?: React.ReactNode
    cardName: string
    cardBottomTag?: string
    onPress?: () => void
    textClass?: string
    customTileText?: React.ReactNode
  }

const TileTag: React.FC<TileTagProps> = ({
  CardIcon,
  cardTagTop,
  cardName,
  cardBottomTag,
  onPress,
  textClass,
  ...props
}) => {
  return (
    <PressableTagFrame onPress={onPress} {...props}>
      <IconFrame>
        {CardIcon && CardIcon}
        {cardTagTop && cardTagTop}
      </IconFrame>
      {props?.customTileText ? (
        props?.customTileText
      ) : (
        <TileText className={textClass}>{cardName}</TileText>
      )}
      {cardBottomTag && <Tag rounded="full">{cardBottomTag}</Tag>}
    </PressableTagFrame>
  )
}

export default TileTag
